export default __webpack_public_path__ + "static/noImage-ebbc7b17947644e301a0856b0be00cc4.png";